import { differenceInHours } from "date-fns/esm";

import User from "@mapmycustomers/shared/types/User";

import { parseApiDate } from "@app/util/parsers";

import { MAX_INACTIVE_HOURS } from "../../scene/map/components/Legends/components/UserLocationsLegendCard/util/const";

const isUserActive = (user: User): boolean =>
  !!user.lastLocation &&
  differenceInHours(new Date(), parseApiDate(user.lastLocation.createdAt)) < MAX_INACTIVE_HOURS;

export default isUserActive;
